<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <el-row class="row">
      <router-link :to="{ name: 'CommunityDetail', params: { id: 17528}}">
        <el-button type="primary">跳转圈子详情1</el-button>
      </router-link>
    </el-row>

    <el-row class="row">
      <router-link :to="{ name: 'CommunityDetail', params: { id: 27337}}">
        <el-button type="primary">跳转圈子详情2</el-button>
      </router-link>
    </el-row>

    <el-row class="row">
      <router-link :to="{ name: 'Privacy'}">
        <el-button type="primary">隐私条款</el-button>
      </router-link>
    </el-row>

    <el-row class="row">
      <router-link :to="{ name: 'Download'}">
        <el-button type="primary">下载APP</el-button>
      </router-link>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'My Vue'
    }
  },
  method() {
      //this.$router.push({ path: '/news', query: { userId: 123 }});

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.row {
  margin: 10px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue